import React, {Fragment,useState } from 'react';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import $, { event } from 'jquery';
import '../NCRMSHome/NcrmStyle.css';
import '../commonStyle/tmsStyle.scss';
import {Link } from "react-router-dom";
import { withRouter } from './withRouter';
import BlockUi from '@availity/block-ui';
import Loaders from '../Loaders';


class NCRMHome extends React.Component{
constructor(props){
super(props);
this.state={GlobalSearchValue:'',MDHideScreen:false,DocType:null,
lblname:'Create Request', GbRole:false,blocking:false,isNewCreate:true,TorType:'',isNew:'', CreateRequests:false,advanceSearch:false};

}

async componentDidMount(){

  $("#myModal,#CarriermyModal").hide();

      // let props = {};
			// let inputObj = {};
			// props["query"] = constants.serviceRoot;
			// props["headers"] = constants.serviceHeaders;
			// inputObj["Activity"] = "GET_USER_DETAILS";
			// inputObj["Input"] = "";
			// props.input = inputObj;
       const userprofile =JSON.parse(sessionStorage.getItem("profile"));
      

      this.state.UserType=userprofile;
      this.state.roleList=userprofile["ROLE_LIST"];



      if(this.state.roleList["BB"]=="True" && this.state.roleList["MDADMIN"]=="True"){

        this.setState({MDHideScreen:false});

      }else if(this.state.roleList["BB"]=="True" && this.state.roleList["MDVIEWER"]=="True"){

        this.setState({MDHideScreen:false});

      }else if(this.state.roleList["BB"]=="True"){

        this.setState({CreateRequests:false});
        this.setState({lblname:'Create Request'});
      
      }

     else if(this.state.roleList["MDADMIN"]=="True" || this.state.roleList["MDVIEWER"]=="True"){

        this.setState({MDHideScreen:true});

      }

      
      if(this.state.roleList["APPROVER"]=="True" && this.state.roleList["MDADMIN"]=="True"){

        this.setState({MDHideScreen:false});
        this.setState({CreateRequests:true});

      }else if(this.state.roleList["APPROVER"]=="True" && this.state.roleList["MDVIEWER"]=="True"){

        this.setState({MDHideScreen:false});
        this.setState({CreateRequests:true});

      }else if(this.state.roleList["APPROVER"]=="True"){

        this.setState({CreateRequests:true});
        //this.setState({lblname:'Create Intel Ship Request'});
      }

      if(this.state.roleList["CW"]=="True"){

        this.setState({GbRole:true,advanceSearch:false});
        this.setState({lblname:'Create Intel Shipment Request'});
      
      }

      if(this.state.roleList["CARRIER"]=="True"){
        this.setState({CreateRequests:false});
        this.setState({lblname:'Create Request'});        
      }

     


}





SearchChanged=(event)=>{

    this.setState({GlobalSearchValue:event.target.value});

}


closebtn=(event)=>{

    $("#myModal").hide();
    event.target.value="";
    this.setState({GlobalSearchValue:event.target.value});
}

async GlobalSearch(event){   
  
     this.setState({blocking:true});
    let PassSearchValue=this.state.GlobalSearchValue;

    

   if(PassSearchValue==null || PassSearchValue=="" || PassSearchValue==undefined){
    toast.error("Please enter value", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });
  
    this.setState({blocking:false});

    return;

   }else{
let obj={};

if(this.state.roleList["CARRIER"]=="True")
{
 obj['querystring']=PassSearchValue;
 obj['carrier_scac']=this.state.UserType.CARRIER_SCAC;
// obj['querystring']="6000004510";
// obj['carrier_scac']="DZNA";
}
else{
obj['querystring']=PassSearchValue;
obj['carrier_scac']="";
}

let props = {};
let inputObjs = {};
let InputJSONString=JSON.stringify(obj);
console.log("InputJSONString",InputJSONString);
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;
inputObjs["Activity"] = "FO_QUICK_SEARCH";
inputObjs["Input"] = InputJSONString;
props.input = inputObjs;
const result = await GatewayGet(props, props.input);
console.log("BOL1111",result);
//count.push(result);
if(this.state.roleList["CARRIER"]=="True")
{

  if(result.length!=0){

    if(result.length==1){      

      sessionStorage.setItem("tor_id",result[0].TOR_ID);
      this.setState({DocType:result[0].TOR_TYPE});
     

      if(this.state.DocType == "ZMSB"){

           toast.error("Please use Request for Quotation menu for RFQ# search");

      }
      else {

      this.setState({isNewCreate:false});
      this.props.navigate('/intelshipment',{ state: {isNew:this.state.isNewCreate,TorType:this.state.DocType}})

        }

    } else if(result.length>=1)
       {
        $("#CarriermyModal").show();
       }

  }
  else
  {

    toast.error("Invalid SCAC Code!!! You are not authorized to view the page.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });
  }
     
}
else {

  if(result.length!=0){
    if(result.length==1){      
      sessionStorage.setItem("tor_id",result[0].TOR_ID);
      this.setState({DocType:result[0].TOR_TYPE});
      this.setState({isNewCreate:false});
     this.props.navigate('/intelshipment',{ state: {isNew:false,TorType:result[0].TOR_TYPE} })
    } 
    else if(result.length>=1){
        $("#myModal").show();
       }

  }else{

    toast.error("Invalid!!!... Request#/ HAWB#/ PRO#", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });

       }
     }
   }

   //event.preventDefault();
   this.setState({blocking:false});

}

CreateRequest=(event)=>{

     

     this.props.navigate('/intelshipment',{ state: {isNew:true,TorType:null} })

     }


render(){

    return(   

        <div>
                      
<BlockUi tag="div" blocking={this.state.blocking}
        
        loader={<Loaders />}>

        <MDBContainer fluid>
        <MDBRow>
            <MDBCol sm="12" className="titleBox"><label>Non-Contracted Rates Management</label></MDBCol>
        </MDBRow>
        </MDBContainer>

        <div className="">
             <div className="app-imageHome">
              <MDBContainer fluid>
              <MDBRow>
              <MDBCol md = "1"></MDBCol>
              {!this.state.MDHideScreen && <MDBCol md = "9">
                <div className="searchTab">
                <table className="table contentTable"><tr>
                {!this.state.GbRole && <td>
                    <div className="searbtn">
                    <input type="text" value={this.state.GlobalSearchValue} onChange={this.SearchChanged} 
                     placeholder="Search with Request#/ HAWB#/ PRO#"  style={{width:"100%",border:'2px solid #004a86',padding:"8px"}} className="form-control searchText"/>
                    <button type="submit" onClick={this.GlobalSearch.bind(this)} className="btn k-button searchCode">
              <i className="fa fa-search"></i></button>
               {/* to={{pathname:'/intelshipment',state:this.state.GlobalSearchValue}} */}
                    </div>                   
                    </td>}
                    {!this.state.CreateRequests &&   <td>
      <button type="submit" onClick={this.CreateRequest} className="btn k-button k-button-icontext" style={{padding:'9px',width:'100%'}}>{this.state.lblname}</button>
      </td>}
      {!this.state.advanceSearch &&  <td>
           <Link to="/FrightOrderSearch"><button type="submit" className="btn k-button k-button-icontext" style={{padding:'9px',width:'100%'}}>Advanced Search</button></Link>
              </td>
          }
              {/* <td><Link to="/Authorized"><button type="submit" className="btn k-button k-button-icontext" style={{padding:'9px'}}>Authorized</button></Link></td> */}

                    </tr></table>
                    
                    </div>

        <div className="modal" id="myModal" style={{marginTop:'6%'}}>		
		<div className="modal-content">
		  <div className="">
			<p className="tti ww">Warning! </p>
			<p className="cls"><button type="button" className="close" onClick={this.closebtn}>&times;</button></p>
		  </div>
		  <div className="modal-body">

        <p className="mlt">
          Multiple NCRM Requests exist with same HAWB#/PRO#.<br /><br />
          Please use <Link to="/FrightOrderSearch">Advance Search</Link> to view the NCRMs.<br/>
          Click <b>Cancel</b> to go back to main screen. </p>
        
         </div>
        <div className="modal-footer">
			<button type="button" className="btn cbtn" onClick={this.closebtn}>Cancel</button>
		  </div>
          </div>
          </div>




          <div className="modal" id="CarriermyModal">		
		<div className="modal-content">
		  <div className="">
			<p className="tti ww">Error! </p>
			<p className="cls"><button type="button" className="close" onClick={this.closebtn}>&times;</button></p>
		  </div>
		  <div className="modal-body">

        <p className="mlt">
          Multiple NCRM Requests exist with same HAWB#/PRO#.<br />
          Please use <Link to="/FrightOrderSearch">Advance Search</Link> to view the NCRMs.<br/>
          Click <b>Cancel</b> to go back to main screen. </p>
        
         </div>
        <div className="modal-footer">
			<button type="button" className="btn cbtn" onClick={this.closebtn}>Cancel</button>
		  </div>
          </div>
          </div>




             
              </MDBCol>}           
              
              </MDBRow>
              
              </MDBContainer>
             </div>
             </div>
             </BlockUi>

        </div>);
}

}




export default withRouter(NCRMHome);

